function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.stopPropagation();
    console.log('SUMMARY CLICK');
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.querySelectorAll('.list-menu__item.facets__item, .facet-checkbox').forEach((facetItem) => {
  facetItem.addEventListener('click', (event) => {
    console.log('DETAILS CLICK');
    event.stopPropagation();
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  console.log(event);
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen){
        event.preventDefault();
      }
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    console.log(event.currentTarget);
    if(!$(event.currentTarget).hasClass('disclosure__button')){
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index].trim() === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        document.dispatchEvent(new CustomEvent('swym:variant-changed', {detail: { data: this.currentVariant}}));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    
    if(productForm.classList.contains('miniform')){
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) {
          addButtonText.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="11.781" height="10.588" viewBox="0 0 11.781 10.588"><path data-name="Compound Path" d="M20.984,17.99l-2.61-3.49-.477.358,2.341,3.132-7.725.045,2.431-3.176-.477-.358-2.7,3.549H10.5l1.432,6.979,8.918.06,1.432-7.113Zm-.611,6.5-7.963-.06-1.178-5.786,10.319-.06Z" transform="translate(-10.5 -14.5)" fill="#fff"></path></svg>';
        }
      } else {
        addButton.removeAttribute('disabled');
        // addButtonText.textContent = window.variantStrings.addToCart;
        addButtonText.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="11.781" height="10.588" viewBox="0 0 11.781 10.588"><path data-name="Compound Path" d="M20.984,17.99l-2.61-3.49-.477.358,2.341,3.132-7.725.045,2.431-3.176-.477-.358-2.7,3.549H10.5l1.432,6.979,8.918.06,1.432-7.113Zm-.611,6.5-7.963-.06-1.178-5.786,10.319-.06Z" transform="translate(-10.5 -14.5)" fill="#fff"></path></svg>';
      }
    }else{
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//     } else {
//       addButton.removeAttribute('disabled');
//       addButtonText.textContent = window.variantStrings.addToCart;
//     }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = '';
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    // this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').value);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class FrenzyModal extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.updateEligibleVariants();
    this.setVariant();
    this.setListeners();
    this.setStockStatus();
    this.atcInit();
  }

  formatPrice(priceString, number) {
    // Remove any existing currency symbols and codes from the input string
    const cleanPrice = priceString.replace(/^[^\d]+|[^\d\s]+$/g, '').trim();

    // Detect locale and format currency properly
    const locale = Shopify.locale || 'en-US'; // Default fallback
    const currency = Shopify.currency.active || 'USD'; // Use store's active currency

    // Format the number with Intl.NumberFormat
    let formattedNumber = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2, // Shopify defaults to 2 decimal places
    }).format(number);

    // Extract the currency symbol from the formatted value
    const currencySymbol = formattedNumber.replace(/[\d.,\s]+/g, '').trim();

    // Remove the currency symbol from the formatted value
    formattedNumber = formattedNumber.replace(currencySymbol, '').trim();

    // Build the final formatted price
    let finalPrice = `${currencySymbol} ${formattedNumber}`;

    // Remove any extra spaces (reduce multiple spaces to a single space)
    return finalPrice.replace(/\s+/g, ' ');
  }

  updatePrice() {
    const active_prod_closest = active_prod_card.closest('.frenzy_grid');
    let variant_for_price = this.current_variant;
    if (!variant_for_price) {
      const current_color = this.querySelector('.frenzy-option-color input[type="radio"]:checked')?.value;
      if (current_color) {
        const productData = JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText);
        productData.color_products.forEach(prod => {
          prod.variants.forEach(variant => {
            if (variant.options[1] === current_color) {
              variant_for_price = variant;
            }
          });
        });
      }
    }  
    if (variant_for_price?.price) {
      const priceMeta = active_prod_closest.querySelector('.frenzy_product_price_meta');
      if (priceMeta) {
        const salePriceEl = priceMeta.querySelector('.frenzy_product_price_sale .money');
        const comparePriceEl = priceMeta.querySelector('.frenzy_product_price_compare .money');
  
        if (variant_for_price.compare_at_price) {
          // Handle sale price
          // salePriceEl.innerText = this.formatPrice(salePriceEl.innerText, variant_for_price.price / 100);
          salePriceEl.innerText = money_format_Frenzy(variant_for_price.price , frenzy_shop_currency);
          // comparePriceEl.innerText = this.formatPrice(comparePriceEl.innerText, variant_for_price.compare_at_price / 100);
          comparePriceEl.innerText = money_format_Frenzy(variant_for_price.compare_at_price , frenzy_shop_currency);
          priceMeta.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
        } else {
          // Handle regular price (no sale)
          // salePriceEl.innerText = this.formatPrice(salePriceEl.innerText, variant_for_price.price / 100);
          salePriceEl.innerText = money_format_Frenzy(variant_for_price.price , frenzy_shop_currency);
          comparePriceEl.innerText = '';
          priceMeta.querySelector('.frenzy_product_price_sale').classList.remove('is-sale');
        }
      }
    }
  }

  updateEligibleVariants() {
    const fieldsets = this.querySelectorAll('.frenzy-option-fieldset'),
      second_selected_option = fieldsets[1].querySelector('.frenzy-option-fieldset input[type="radio"]:checked').value;
    if(fieldsets.length == 2) {
      fieldsets[0].querySelectorAll('.frenzy-option-fieldset input[type="radio"]').forEach(opt=>{
        const var_title = opt.value + ' / ' + second_selected_option;
          let var_found = false;
        JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText).color_products.forEach(prod=>{
          prod.variants.forEach(variant=> {
            if(variant.title == var_title) {
              var_found = true;
              if(variant.available) {
                opt.closest('li').classList.remove('not-available');
              } else {
                opt.closest('li').classList.add('not-available');
              }
            }
          })
        });
        if(!var_found) {
          opt.closest('li').classList.add('not-available');
        }
      });
    } else if(fieldsets.length == 3) {
      if(second_selected_option) {
        const last_selected_option = fieldsets[2].querySelector('.frenzy-option-fieldset input[type="radio"]:checked').value;
        fieldsets[0].querySelectorAll('.frenzy-option-fieldset input[type="radio"]').forEach(opt=>{
          const var_title =  opt.value + ' / ' + second_selected_option + ' / ' + last_selected_option;
          let var_found = false;
          JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText).color_products.forEach(prod=>{
            prod.variants.forEach(variant=> {
              if(variant.title == var_title) {
                var_found = true;
                if(variant.available) {
                  opt.closest('li').classList.remove('not-available');
                } else {
                  opt.closest('li').classList.add('not-available');
                }
              }
            })
          });
          if(!var_found) {
            opt.closest('li').classList.add('not-available');
          }
        });
      }
    }
    const sizeFieldset = this.querySelector('.frenzy-option-fieldset.frenzy-option-size .frenzy-option-selector-btns');
    const colorFieldset = this.querySelectorAll('.frenzy-option-fieldset.frenzy-option-color .color-variants-custom li');
    const cartBtn = this.querySelector('.frenzyQuickViewAddToCart');
    
    colorFieldset.forEach((colorItem) => {
      colorItem.addEventListener('click',function(this_click){
        let sizeHTML = '';
        let selected = false; 
        const proSizes = JSON.parse(this_click.target.closest('label').dataset.productSizes || '');
        const sizeIndex = this_click.target.closest('label').dataset.sizeIndex;
        const productId = this_click.target.closest('label').dataset.productId;
        const productUrl = window.location.origin + this_click.target.closest('label').dataset.productUrl;
        const productData = JSON.parse(this_click.target.closest('label').getAttribute('data-product-json')) || '';
        const variantId = this_click.target.closest('label').dataset.variantId;
        const colorTitle = this_click.target.closest('label').dataset.colorTitle;
        function safeStringify(obj) {
          return JSON.stringify(obj).replace(/"/g, '&quot;').replace(/'/g, '&apos;');
        }
        const allImages = productData?.images;
        if (allImages.length === 0) return;
        const swiperContainer = active_prod_card.closest('.frenzy_product_item').querySelector('.frenzy_product_item_slider figure a');
        const productTitle = active_prod_card.closest('.frenzy_product_item').querySelector('.frenzy_product_title a');
        swiperContainer.setAttribute('href',productUrl);
        productTitle.setAttribute('href',productUrl);
        if(window.innerWidth < 768){
          let updateMobImages = '';
          const wrapper = swiperContainer.querySelector('.frenzy-mobile-image-grid');
          wrapper.innerHTML = '';
          allImages.slice(0, 2).forEach((img, i) => {
            const slide = document.createElement('div');
            const resizedImg = img.replace(/(\.(jpg|jpeg|png|webp))(.*)?$/, '_250x$1');
            slide.className = 'swiper-slide';
            const imgClass = i === 0 ? 'frenzy_img frenzy_img_first' : 'frenzy_img frenzy_img_second';
            slide.innerHTML = `<img class="${imgClass}" src="${resizedImg}" alt="" />`;
            wrapper.appendChild(slide);
          });
          wrapper.setAttribute('data-all-images', JSON.stringify(allImages));
          wrapper.setAttribute('data-loaded-count', '2');
          if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
            swiperContainer.swiper = null;
          }
          setTimeout(() => {
            mobielSwiperCall(swiperContainer,active_prod_card.closest('.frenzy_product_item'),allImages);
          }, 300);
        }
        (proSizes || []).forEach((size,i) => {
          const matchingSize = size[sizeIndex];
          let sizeDisabled = '';
          let selectedSize = '';
          if(size.available === false){
            sizeDisabled = 'is_disabled not-available';
          }else if (!selected) {
            selectedSize = 'checked';
            selected = true;
          }
          if(size.available === false){
            sizeHTML += `<li class="size-li clickforsku-outer ${sizeDisabled}">
            <label for="option-Size-${matchingSize}" data-available="${size.available}" data-variant-id="${size.id}" data-variantsku="${size.sku}" data-product-id="${productId}">
              <span>${matchingSize}</span>
              <input ${selectedSize} value="${matchingSize}" id="option-Size-${matchingSize}" type="radio" name="option-Size">
            </label>
            <a href="#" class="BIS_trigger desktops la" data-product-id="${productId}" data-variantid="${size.id}" data-variant-id="${size.id}" data-product-url="${productUrl}" data-product-data="${safeStringify(productData)}"></a>
            </li>`;
          }else{
            sizeHTML += `<li class="size-li clickforsku-outer">
            <label for="option-Size-${matchingSize}" data-available="${size.available}" data-variant-id="${size.id}" data-variantsku="${size.sku}" data-product-id="${productId}">
              <span>${matchingSize}</span>
              <input ${selectedSize} value="${matchingSize}" id="option-Size-${matchingSize}" type="radio" name="option-Size">
            </label>
            </li>`;
          }
        })
        sizeFieldset.innerHTML = sizeHTML;
        const selectedInput = document.querySelector('input[name="option-Size"]:checked');
        const selectedVariantId = selectedInput?.closest('label')?.getAttribute('data-variant-id');
        if(productData.available === false){
          cartBtn.innerHTML = 'Sold Out';
          cartBtn.classList.add('disabled');
          cartBtn.setAttribute('data-id','');
        }else{
          cartBtn.innerHTML = 'Add to Cart';
          cartBtn.classList.remove('disabled');
          cartBtn.setAttribute('data-id',selectedVariantId);
        }
        cartBtn.setAttribute('data-product_id',productId);
        const checkColor = active_prod_card.closest('.frenzy_product_item').querySelectorAll('.collection-swatch .frenzy-swatch_item[data-variant-id="'+variantId+'"]');
        active_prod_card.closest('.frenzy_product_item').querySelector('.product_card_color_title').innerText = colorTitle;
        
        if(checkColor.length > 0){
          active_prod_card.closest('.frenzy_product_item').querySelectorAll('.collection-swatch .frenzy-swatch_item[data-variant-id="'+variantId+'"]').forEach((this_clr) => {
            const this_closest = this_clr?.closest('.custom-collection-swatches').querySelectorAll('.collection-swatch');
            const this_parentEle = this_clr?.closest('.collection-swatch');
            this_closest.forEach(item => {
              item.classList.remove('clicked','current_item');
            });
            this_parentEle.click();
            this_parentEle.classList.add('clicked','current_item');
          });
        }else{
          active_prod_card.closest('.frenzy_product_item').querySelectorAll('.collection-swatch').forEach((clrItm) => {
            clrItm.classList.remove('clicked','current_item');
          })
        }
      });
    });
    
    sizeFieldset.querySelectorAll('li label').forEach((sizeItem) => {
      sizeItem.addEventListener('click',function(this_click){
        sizeFieldset.querySelectorAll('li label').forEach(label => {
          const input = label.querySelector('input[type="radio"]');
          if (input) input.removeAttribute('checked');
        });
        const radioInput = this_click.target.closest('input[type="radio"]');
        if (radioInput) radioInput.removeAttribute('checked','');
        const getVarId = this_click.target.closest('label').dataset.variantId;
        const productId = this_click.target.closest('label').dataset.productId;
        cartBtn.setAttribute('data-id',getVarId);
        cartBtn.setAttribute('data-product_id',productId);
      })
    });
  }
  
  setVariant() {
    let variant_title = ''
    this.querySelectorAll('input[type="radio"]:checked').forEach((input,i,arr)=>{
      variant_title += input.value;
      if( i != arr.length-1) {
        variant_title += ' / '
      }
    });
    this.current_variant = null;
    JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText).color_products.forEach(prod=>{
      prod.variants.forEach(variant=>{
        if(variant.title == variant_title) {
          this.current_variant = variant;
        }
      })
    })
    console.log(variant_title,this.current_variant);
  }
  setListeners() {
    this.querySelectorAll('input[type="radio"]').forEach(function(input){
      input.addEventListener('input',function(e){ 
        this.setVariant();
        this.updateEligibleVariants();
        this.updatePrice();
        this.setStockStatus();
        this.updateMetafieldBadge();
        this.updateSoldOutBadge();
        // this.updateCardImage(e);
      }.bind(this));
    }.bind(this));
  }
  updateMetafieldBadge() {
    const selected_color = this.querySelector('.frenzy-option-color input:checked').value;
     let has_badge = false;
     JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText).color_products.forEach(prod=>{
        prod.variants.forEach(variant=>{
          if(variant.option2 == selected_color && prod.tag_title && !has_badge) {
            if(active_prod_card.querySelector('.frenzy_product_tag_badge')) {
              active_prod_card.querySelector('.frenzy_product_tag_badge').insertAdjacentHTML('afterend',`<div class="frenzy_product_tag_badge"><div class="frenzy_product_tag_badge_inner"><span>${prod.tag_title}</span></div></div>`);
              active_prod_card.querySelector('.frenzy_product_tag_badge').remove();
            } else {
              active_prod_card.querySelector('.frenzy_product_tags').insertAdjacentHTML('afterbegin',`<div class="frenzy_product_tag_badge"><div class="frenzy_product_tag_badge_inner"><span>${prod.tag_title}</span></div></div>`);
            }
            has_badge = true;
          }
        })
      })
     if(!has_badge) {
       active_prod_card.querySelector('.frenzy_product_tag_badge')?.remove();
     }
  }
  updateSoldOutBadge() {

    let current_color = this.querySelector('.frenzy-option-color input:checked').value;
    let is_sold_out = true;
    JSON.parse(this.querySelector('#frenzy_procut_feed_data').innerText).color_products.forEach(prod=>{
      prod.variants.forEach(variant=>{
        if(variant.option2 == current_color && variant.available) {
          is_sold_out = false;
        }
      })
    })
    
    const productItem = active_prod_card.closest('.frenzy_product_item');
    let badgeContainer = productItem.querySelector('.frenzy_product_soldout_badge');

    // Get the value of the "data-soldout" attribute from the clicked variant
    const soldoutTag = is_sold_out ? 'true' : 'false';

    // Set or update the data attribute on the product item or variant element
    productItem.setAttribute('data-soldout', soldoutTag);

    // Check if the product is sold out (data-soldout is "true")
    if (soldoutTag === 'true') {
        if (!badgeContainer) {
            // Create and insert the badge if it doesn’t exist
            badgeContainer = document.createElement("div");
            badgeContainer.classList.add("frenzy_product_soldout_badge");
            badgeContainer.innerHTML = `<div class="frenzy_product_soldout_badge_inner"><span>SOLD OUT</span></div>`;
            productItem.querySelector('.frenzy_product_tags').appendChild(badgeContainer);
        }
    } else {
        // Remove badge if variant is available
        if (badgeContainer) {
            badgeContainer.remove();
        }
    }
  }
  updateCardImage(e) {
    if(e.target.closest('[data-img]') && active_prod_card) {
      console.log(active_prod_card.querySelector('img'))
      active_prod_card.querySelector('img').src = e.target.closest('[data-img]').dataset.img;
     // active_prod_card.querySelector('img').srcset = e.target.closest('[data-img]').dataset.img;
    }
  }
  setStockStatus(){
    // if(this.current_variant?.available) {
    //   this.querySelector('.frenzyQuickViewAddToCart').disabled = false;
    //   this.querySelector('.frenzyQuickViewAddToCart').innerText = 'Add to cart';
    // } else {
    //   this.querySelector('.frenzyQuickViewAddToCart').disabled = true;
    //   this.querySelector('.frenzyQuickViewAddToCart').innerText = 'Unavailable';
    // }
  }
  atcInit() {
    this.querySelector('.frenzyQuickViewAddToCart').addEventListener('click',function(e) {
      if(this.current_variant) {
        const product_id = e.target.getAttribute('data-product_id');
        const var_id = e.target.getAttribute('data-id');
        const sku = product_id + '_' + var_id;
        window.quickviewProperties._sku = sku;
        let formData = {
         'items': [{
          'id': var_id,
          'quantity': 1,
          'properties': window.quickviewProperties
          }],
          'sections': 'cart-drawer,cart-icon-bubble,cart-live-region-text,cart_footer'

        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(data=>{
          if(data.status != 422) {
            frenzyProductAddToCartEventApi(sku);
            this.querySelector('.frenzy-modal-close').click();
            if(document.querySelector('cart-items') != null){
              document.querySelector('cart-items').renderContents(data);
              document.querySelector('cart-items').viewDrawer();
            }
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    }.bind(this))
  }
}
customElements.define('frenzy-modal',FrenzyModal);




$(".content .accordion").click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
    });
});


$(".careers_grid .ambs_faq_accordion").click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
    });
});

var backToTopButton = $('#back-to-top');
    
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 300) {
            backToTopButton.show();
        } else {
            backToTopButton.hide();
        }
    });
    
    backToTopButton.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        
        setTimeout(function() {
            $('#backtoheader').focus();
        }, 600);
    });